<!-- Apple-style Header -->
<app-page-header
  title="Ausstehende Aufträge"
  subtitle="Übersicht aller Aufträge, die auf Genehmigung warten"
  icon="pending_actions"
  variant="gradient">
</app-page-header>

<!-- Apple-style Content -->
<div class="apple-slide-up">
  <div class="apple-pending-orders-content">
    <!-- Orders Table Card -->
    <div class="apple-card orders-card">
      <div class="apple-card-header">
        <div class="apple-card-icon orders-icon">
          <mat-icon>pending_actions</mat-icon>
        </div>
        <div class="apple-card-title-section">
          <h3>Ausstehende Aufträge</h3>
          <p class="apple-body-secondary">
            {{ (pendingOrders$ | async)?.length || 0 }} Aufträge warten auf Genehmigung
          </p>
        </div>
      </div>

      <div class="apple-card-content">
        <div class="orders-table-wrapper">
          <table class="apple-table">
            <thead>
              <tr>
                <th class="apple-table-header">Auftragsnr.</th>
                <th class="apple-table-header">Kunde</th>
                <th class="apple-table-header">Status</th>
                <th class="apple-table-header">Anzahl Coins</th>
                <th class="apple-table-header">Coins angewendet am</th>
                <th class="apple-table-header">Angewendet von</th>
                <th class="apple-table-header">Aktionen</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let order of pendingOrders$ | async" class="apple-table-row status-pending">
                <td class="apple-table-cell">{{ order.reflexOrderNo }}</td>
                <td class="apple-table-cell">
                  <div class="customer-info">
                    <mat-icon class="customer-icon">business</mat-icon>
                    <span>{{ order.customer?.reflexCustomerNo || order.customer?.customerReflexId || 'N/A' }}</span>
                  </div>
                </td>
                <td class="apple-table-cell">
                  <span class="status-badge badge-pending">
                    {{ order.status?.name }}
                  </span>
                </td>
                <td class="apple-table-cell">
                  <span class="coins-value">{{ order.coinsUsed }}</span>
                </td>
                <td class="apple-table-cell">
                  {{ order.createdDate | date : "dd.MM.yyyy HH:mm" : "UTC" }}
                </td>
                <td class="apple-table-cell">
                  <div class="user-info">
                    <mat-icon class="user-icon">person</mat-icon>
                    <span>
                      {{ order.customer?.userDetails?.firstName }}
                      {{ order.customer?.userDetails?.lastName }}
                    </span>
                  </div>
                </td>
                <td class="apple-table-cell actions-cell">
                  <button 
                    class="apple-button apple-button-small apple-button-success" 
                    matTooltip="Genehmigen"
                    [disabled]="!order.id"
                    (click)="order.id && changeOrderStatus(order.id, 'approve')">
                    <mat-icon>check_circle</mat-icon>
                  </button>
                  <button 
                    class="apple-button apple-button-small apple-button-error" 
                    matTooltip="Ablehnen"
                    [disabled]="!order.id"
                    (click)="order.id && changeOrderStatus(order.id, 'decline')">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="(pendingOrders$ | async)?.length === 0" class="apple-table-row empty-state">
                <td colspan="7" class="apple-table-cell empty-cell">
                  <div class="empty-state-content">
                    <mat-icon class="empty-icon">check_circle</mat-icon>
                    <p class="empty-message">Keine ausstehenden Aufträge</p>
                    <p class="empty-submessage">Alle Aufträge wurden bearbeitet</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
